import axios from 'axios';
const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api/rail`;

// Submit rail data (create)
export const submitRailData = async (data) => {
  const response = await axios.post(`${API_BASE_URL}/submit`, data);
  return response;
};

// Get rails for a drive (with GPS coordinates)
export const getRailsForDrive = async (driveId) => {
  const response = await axios.get(`${API_BASE_URL}/${driveId}`);
  return response;
};

// Get rail GPS data from backend
export const getRailGpsData = async (driveId) => {
  const response = await axios.get(`${API_BASE_URL}/${driveId}/gps`);
  return response;
};
